import { flatten, propEq } from 'ramda'

import { truncateString } from '../../packages/kiti/utils/helpers/string'
import { useQuestionsFromApi } from '../helpers/questions'

const genQuestionInterpolationValue = (question, repliesOrigin, func = 'sum', opts) => {
  if (question.insideBlock && NUMERIC_TYPES.includes(question.typeName)) {
    return `{{#filter ${repliesOrigin} field="question_id" operator="eq" value=${question.id}}}{{${func} self field="value"}}{{/filter}}`
  }
  switch (question.typeName) {
    case 'block':
      return `{{#block_question ${repliesOrigin} field="question.id" operator="eq" value=${question.id}}}{{${
        opts?.block_as_table ? 'as_table ' : ''
      }reply.value}}{{/block_question}}`
    case 'sign':
      return `{{#find ${repliesOrigin} field="question_id" operator="eq" value=${question.id}}}__HTML_CONTENT_INIT__{{self.value.src}}__HTML_CONTENT_END__{{/find}}`
    case 'gallery':
      if (opts?.isImageInterpolation) {
        return `{{#find ${repliesOrigin} field="question_id" operator="eq" value=${question.id}}}{{#each reply.value}}__HTML_CONTENT_INIT__{{self.src}}__HTML_CONTENT_END__{{/each}}{{/find}}`
      }
      return `{{#find ${repliesOrigin} field="question.id" operator="eq" value=${question.id}}}{{to_urls reply.value}}{{/find}}`
    case 'date':
    case 'datetime':
      return `{{#find ${repliesOrigin} field="question_id" operator="eq" value=${question.id}}}{{format_date reply.value}}{{/find}}`

    case 'place':
      return `{{#find_field_value ${repliesOrigin} field="question_id" operator="eq" value=${question.id} field_id=#field_id#}}{{reply.value}}{{/find_field_value}}`
    default:
      return `{{#find ${repliesOrigin} field="question_id" operator="eq" value=${question.id}}}{{reply.value}}{{/find}}`
  }
}

const NUMERIC_TYPES = ['float', 'numeric', 'decimal']

export const DEFAULT_REPLY_QUESTION_TYPES = [
  'text',
  'decimal',
  'numeric',
  'checkbox',
  'place',
  'asset',
  'user',
  'gallery',
  'select',
  'multiple',
  'date',
  'datetime',
  'address',
  'location',
  'float',
  'block',
  'sign',
  'place_location',
  'place_person'
]

export const useRepliesInterpolationsFetcher = (skip, repliesOrigin, checklistId, opts) => {
  const questionTypes = opts?.replyQuestionTypes ?? DEFAULT_REPLY_QUESTION_TYPES

  const { data: questionsData } = useQuestionsFromApi(checklistId, questionTypes, { skip })

  let questions = questionsData?.questions || []
  questions = flatten(
    questions.map(question => {
      const parentQuestion = questions.find(propEq('reference', question.parentReference))
      if (parentQuestion?.typeName === 'block') {
        return [
          { ...question, name: `Soma: ${question.name}`, insideBlock: true, func: 'sum' },
          { ...question, name: `Média: ${question.name}`, insideBlock: true, func: 'avg' }
        ]
      }
      return question
    })
  )

  return questions
    .filter(question => {
      if (question.insideBlock && !NUMERIC_TYPES.includes(question.typeName)) return false
      return true
    })
    .map(question => {
      return {
        name: truncateString(question.name, 30),
        fullName: question.name,
        description: truncateString(question.category?.name, 30),
        id: genQuestionInterpolationValue(question, repliesOrigin, 'sum', opts),
        type: question.typeName,
        nodeType:
          (question.typeName === 'gallery' && opts?.interpolation_as_image) || question.typeName === 'sign'
            ? 'images_interpolation'
            : 'interpolation',
        group: 'Respostas'
      }
    })
}
